/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import SmartsRecommenderService from './SmartsRecommenderService';
import StringResources from 'nls/StringResources';

const USER_MESSAGES = {
	'Smarts-IFR-49':{
		'title': StringResources.get('error_something_unexpected'),
		'description': StringResources.get('startingPoints_unsupported_source_type_toast')
	},
	'Smarts-IFR-21':{
		'title': StringResources.get('error_something_unexpected'),
		'description': StringResources.get('startingPoints_unenriched_package_toast')
	},
	'Smarts-IFR-45':{
		'title': StringResources.get('startingPoints_error_title_relationshipDiagram_missingSmartsModule'),
		'description': StringResources.get('startingPoints_error_instructions_missingSmartsModule')
	},
	'Smarts-IFR-48':{
		'title': StringResources.get('startingPoints_error_title_relationshipDiagram_missingSmartsModule'),
		'description': StringResources.get('startingPoints_error_instructions_missingSmartsModule')
	}
};

class SmartsInterestingFieldRecommenderService extends SmartsRecommenderService{

	constructor(options) {
		super(options);
	}

	recommendInterestingFields(requestParams) {
		const SMARTS_ROOT = 'v1/smarts';
		const INTERESTING_FIELDS_URL = SMARTS_ROOT + '/insights/interesting-fields';
		this.logger.debug('recommendInterestingFields');

		return this._executeRequest(requestParams, INTERESTING_FIELDS_URL)
			.catch( this._handleError.bind(this) )
			.then( this._processResponse.bind(this) );
	}
	/**
	 * @override getErrorCodeMappings from SmartsRecommenderService
	 * @return {Object} a map that contains map of <error_Code> : { 'title' : xxx, 'description': xxx}
	 */
	getErrorCodeMappings(){
		return USER_MESSAGES;
	}
}
export default SmartsInterestingFieldRecommenderService;



// WEBPACK FOOTER //
// ./src/js/util/SmartsInterestingFieldRecommenderService.js